module.exports = __webpack_public_path__ + "img/notebookpack.c631b0c8.jpeg";